import { useCallback } from 'react'
import { normalizeMessages } from '@/features/chat/messageNormalize'
import { prepareRegenerateTurn } from './helpers/prepareRegenerateTurn'
import { scheduleCompletionUpdate } from './helpers/scheduleCompletionUpdate'

/** @param {object} m @param {ReturnType<typeof import('./useExchangeVersionActions').useExchangeVersionActions>} v */
export function useRegenerateAssistantAction(m, v) {
  const { messagesByThreadId, chatAbortRef, setMessagesByThreadId } = m
  const { getNextAssistantVersionIndex, setExchangeActiveAnswerVersion } = v
  const handleRegenerateAssistantVersion = useCallback(
    ({ threadId, exchangeId, versionIndex, mode }) => {
      const tid = threadId
      chatAbortRef.current?.abort()
      const controller = new AbortController()
      chatAbortRef.current = controller
      const { signal } = controller
      const list = normalizeMessages(messagesByThreadId[tid] ?? [])
      const baseUser = list
        .filter((msg) => msg.role === 'user' && msg.exchangeId === exchangeId && msg.versionIndex === versionIndex)
        .sort((a, b) => (a.createdAt ?? 0) - (b.createdAt ?? 0))[0]
      const baseText = String(baseUser?.text ?? '').trim()
      if (!baseText) return
      const nextAssistantIndex = getNextAssistantVersionIndex(tid, exchangeId, versionIndex)
      const turn = prepareRegenerateTurn({
        tid,
        messages: list,
        exchangeId,
        versionIndex,
        nextAssistantIndex,
        baseText,
        mode,
      })
      setMessagesByThreadId((prev) => {
        return { ...prev, [tid]: [...turn.priorMessages, turn.pendingAssistant] }
      })
      scheduleCompletionUpdate({
        tid,
        pendingId: turn.pendingId,
        signal,
        setMessagesByThreadId,
        apiMessages: turn.apiMessages,
        mode,
      })
      setExchangeActiveAnswerVersion(exchangeId, nextAssistantIndex)
    },
    [getNextAssistantVersionIndex, messagesByThreadId, setExchangeActiveAnswerVersion, chatAbortRef, setMessagesByThreadId],
  )
  return { handleRegenerateAssistantVersion }
}
